import { useMutation, useQueryClient } from '@tanstack/react-query';
import { put } from '@truefit/http-utils';

import {
  OUTPUT_PROFILES_QUERY_KEY,
  type OutputProfileMode,
} from './useOutputProfilesQuery';
import { TRANSCODING_PROFILES_QUERY_KEY } from './useTranscodingProfilesQuery';

export interface SetOutputProfileAssignmentProps {
  mode: OutputProfileMode;
  profileId: number;
}

export interface SetOutputProfileAssignmentResponse {
  success: boolean;
  mode: OutputProfileMode;
  profileId: number;
}

export const useSetOutputProfileAssignmentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      model: SetOutputProfileAssignmentProps,
    ): Promise<SetOutputProfileAssignmentResponse> => {
      const { data } = await put<SetOutputProfileAssignmentResponse>(
        '/v1.0/internals/output-profiles',
        model,
      );
      return data;
    },
    onSuccess: () => {
      // Refresh both surfaces: the (legacy) assignment query and the
      // transcoding-profiles table, whose `assignedModes` drives the Targets
      // column — assigning a target also moves it off its previous profile, so
      // every row must refetch.
      queryClient.invalidateQueries({ queryKey: OUTPUT_PROFILES_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TRANSCODING_PROFILES_QUERY_KEY });
    },
  });
};

export default useSetOutputProfileAssignmentMutation;
